"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_GraphDefinition_Compartment = exports.GraphDefinition_CompartmentRuleKind = exports.GraphDefinition_CompartmentUseKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var GraphDefinition_CompartmentUseKind;
(function (GraphDefinition_CompartmentUseKind) {
    GraphDefinition_CompartmentUseKind["_condition"] = "condition";
    GraphDefinition_CompartmentUseKind["_requirement"] = "requirement";
})(GraphDefinition_CompartmentUseKind = exports.GraphDefinition_CompartmentUseKind || (exports.GraphDefinition_CompartmentUseKind = {}));
var GraphDefinition_CompartmentRuleKind;
(function (GraphDefinition_CompartmentRuleKind) {
    GraphDefinition_CompartmentRuleKind["_identical"] = "identical";
    GraphDefinition_CompartmentRuleKind["_matching"] = "matching";
    GraphDefinition_CompartmentRuleKind["_different"] = "different";
    GraphDefinition_CompartmentRuleKind["_custom"] = "custom";
})(GraphDefinition_CompartmentRuleKind = exports.GraphDefinition_CompartmentRuleKind || (exports.GraphDefinition_CompartmentRuleKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_GraphDefinition_Compartment = t.recursion('IGraphDefinition_Compartment', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        use: (0, EnumType_1.createEnumType)(GraphDefinition_CompartmentUseKind, 'GraphDefinition_CompartmentUseKind'),
        _use: RTTI_Element_1.RTTI_Element,
        code: RTTI_code_1.RTTI_code,
        _code: RTTI_Element_1.RTTI_Element,
        rule: (0, EnumType_1.createEnumType)(GraphDefinition_CompartmentRuleKind, 'GraphDefinition_CompartmentRuleKind'),
        _rule: RTTI_Element_1.RTTI_Element,
        expression: t.string,
        _expression: RTTI_Element_1.RTTI_Element,
        description: t.string,
        _description: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_GraphDefinition_Compartment.js.map